export default {
  login: '登录',
  index: '首页',
  messageAccount: '短信账户配置',
  MessageTemplate: '消息模板管理',
  MessageConfig: '消息发送配置',
  MessageHistory: '消息发送记录',
  map: '地图定位',
  siteOverview: '站点列表',
  deviceOverview: '设备概览',
  historicalData: '历史数据',
  curveAnalysis: '曲线分析',
  faultStatistics: '报警统计',
  statisticalAnalysis: '统计分析',
  operationStatistics: '运行统计',
  comparativeAnalysis: '对比分析',
  faultManagement: '报警管理',
  system: '系统配置',
  userManage: '账号管理'
}
